import { render, staticRenderFns } from "./MovimientoArticulo.vue?vue&type=template&id=3ad5f3da&scoped=true"
import script from "./MovimientoArticulo.vue?vue&type=script&lang=js"
export * from "./MovimientoArticulo.vue?vue&type=script&lang=js"
import style0 from "./MovimientoArticulo.vue?vue&type=style&index=0&id=3ad5f3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad5f3da",
  null
  
)

export default component.exports